<div class="header">
  <div class="logo-box">
    <a href="/account/">
      @if (logoURL$ | async; as logoURL) {
        <div>
          <img [src]="logoURL" id="wl-store-logo" />
        </div>
      }
    </a>
  </div>
  @if ((selfSignupEnabled$ | async) && !hideSignIn) {
    <div class="header-right">
      <button style="display: none" class="store-button store-button-primary">
        <i class="material-icons button_icon_position">shopping_cart</i>
        Cart (0)
      </button>
      <button class="store-button" (click)="signIn(false)">Sign In</button>
      <button type="button" class="store-button" (click)="signIn(true)">Create an account</button>
    </div>
  }
</div>
